import { Button, Dialog, DialogTitle, TextField, Typography, Box, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, Grid2, darken } from "@mui/material";
import { Dispatch, ReactElement, ReactNode, SetStateAction, useEffect, useState } from "react";
import "./CreateTicket.css";
import { useMsal } from "@azure/msal-react";
import CloseIcon from "@mui/icons-material/Close";
import useFetchMsal from "../../Common/UI/hooks/useFetchMsal";
import { config } from "../../authConfig";
import { LoadingIndicator } from "../../Common/UI/components/Loading";
import { CardContainer } from "./CardContainer";
import { theme } from "../../Common/UI/styles/theme";
import useIsAdminAndViewOnly from "../../Common/UI/hooks/useIsAdminAndViewOnly";

export interface SimpleDialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
}

function SimpleDialog(props: SimpleDialogProps) {
  const { onClose, open, children, title } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>
        <Grid2 container>
          <Grid2 size={10}>
            <>{title}</>
          </Grid2>
          <Grid2 size={2} className="close-icon-container">
            <CloseIcon onClick={onClose} className="close-btn" />
          </Grid2>
        </Grid2>
      </DialogTitle>
      {children}
    </Dialog>
  );
}

function CreateTicket({
  ticketDescription = "",
  ticketSubject = "",
  dialogOpen,
  setDialogOpen,
}: {
  ticketDescription?: string;
  ticketSubject?: string;
  dialogOpen: boolean;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}): ReactElement {
  const execute = useFetchMsal();
  const { accounts } = useMsal();
  //modal
  const [open, setOpen] = useState<boolean>(dialogOpen);
  const { isAdmin } = useIsAdminAndViewOnly();

  const [description, setDescription] = useState<string>(ticketDescription);
  const [subject, setSubject] = useState<string>(ticketSubject);
  const [email, setEmail] = useState<string>("");
  const [priority, setPriority] = useState<number>(3);
  const [status, setStatus] = useState<number>(2);
  const [groupId, setGroupId] = useState<number>(4000274586);

  const [createTicketLoading, setCreateTicketLoading] = useState<boolean>(false);

  useEffect(() => {
    setEmail(accounts[0]?.username);
  }, []);

  function handleCreateTicket() {
    const payload = {
      subject: subject,
      description: description,
      email: email,
      priority: priority,
      status: status,
      group_id: groupId,
    };

    setCreateTicketLoading(true);

    const url = config.rootAPIList?.createTicket;
    execute("POST", `${config.rootAPIUrl}${url}`, payload)
      .then((result) => {
        setCreateTicketLoading(false);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        handleClose();
      });
  }

  const handleClose = () => {
    setDialogOpen(false);
    setOpen(false);
    setSubject(ticketSubject);
    setDescription(ticketDescription);
    setEmail(accounts[0]?.username);
    setCreateTicketLoading(false);
  };

  return (
    <SimpleDialog title="Create Ticket" key="create-ticket-key" open={open} onClose={handleClose}>
      <LoadingIndicator show={createTicketLoading}>
        <Grid2 container spacing={2} sx={{ margin: "20px" }}>
          <Grid2 size={12}>
            <TextField fullWidth required label="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} />
          </Grid2>
          <Grid2 size={12}>
            <TextField fullWidth required label="Email" value={email} disabled={true} onChange={(e) => setEmail(e.target.value)} />
          </Grid2>
          <Grid2 size={12}>
            <Typography>Assigned to Group: Application Development</Typography>
          </Grid2>
          <Grid2 size={6}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Priority</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={priority + ""}
                label="Priority"
                onChange={(event: SelectChangeEvent) => {
                  setPriority(event.target.value as unknown as number);
                }}
              >
                <MenuItem value={1}>Low</MenuItem>
                <MenuItem value={2}>Medium</MenuItem>
                <MenuItem value={3}>High</MenuItem>
                <MenuItem value={4}>Urgent</MenuItem>
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={6}></Grid2>

          <Grid2 size={12}>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "100%" },
                height: "120px",
              }}
              noValidate
              autoComplete="off"
              className="ticket-description"
            >
              <div>
                <TextField
                  id="standard-multiline-static"
                  label="Description"
                  multiline
                  rows={4}
                  defaultValue={description}
                  variant="standard"
                  className="txt-area"
                  onChange={(ev) => {
                    setDescription(ev.target.value);
                  }}
                />
              </div>
            </Box>
          </Grid2>

          <Grid2 size={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              disabled={!isAdmin || createTicketLoading}
              sx={{
                alignSelf: "flex-end",
                mb: 1,
                mt: 2,
                backgroundColor: theme.palette.primary.main,
                "&:hover": {
                  backgroundColor: darken(theme.palette.primary.main, 0.1),
                },
              }}
              onClick={handleCreateTicket}
            >
              Save
            </Button>
          </Grid2>
        </Grid2>
        
        
      </LoadingIndicator>
    </SimpleDialog>
  );
}
export default CreateTicket;
